export enum CCRDiscrepanciesNotificationPreference {
    No = "No",
    Yes = "Yes",
    YesWhenExceedsAmount = "YesWhenExceedsAmount",
}
